import { Zap, Battery, Info } from 'lucide-react';
import * as React from 'react';
import { Card } from '#app/components/ui/card';
import { Separator } from '#app/components/ui/separator';

export default function Speed({
  averageSpeed,
  maxSpeed,
}: {
  averageSpeed: number;
  maxSpeed: number;
}) {
  const infoItems = [
    {
      icon: Battery,
      label: 'Potência Média',
      value: `${Math.round(averageSpeed)} kW`,
      iconFill: 'text-blue-500',
    },
    {
      icon: Zap,
      label: 'Potência Máxima',
      value: `${Math.round(maxSpeed)} kW`,
      iconFill: 'text-yellow-500',
    },
  ];

  return (
    <Card className='overflow-hidden bg-white shadow-sm backdrop-blur-sm'>
      <div className='p-5'>
        <div className='mb-4 flex items-center gap-2'>
          <Zap className='h-5 w-5 text-primary' />
          <h3 className='text-lg font-semibold'>Potência</h3>
        </div>
        <div className='space-y-4'>
          {infoItems.map((item, index) => (
            <React.Fragment key={index}>
              <div className='group flex items-start gap-3'>
                <div className='mt-0.5'>
                  <item.icon
                    className={`h-4 w-4 ${item.iconFill}`}
                    fill='currentColor'
                    aria-hidden='true'
                  />
                </div>
                <div className='flex flex-1 items-center justify-between'>
                  <p className='font-semibold text-sm text-foreground/90'>
                    {item.label}
                  </p>
                  <p className='text-sm font-bold text-foreground'>
                    {item.value}
                  </p>
                </div>
              </div>
              {index < infoItems.length - 1 && (
                <Separator className='bg-border/40' />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </Card>
  );
}
